function j360_hover_image_mouse_move(event) {
  const [hoverImage] = document.getElementsByClassName('j360-list-hover-image');
  const [relativeElement] = document.getElementsByClassName('wp-block-j360-list');

  var parentOffset = relativeElement.getBoundingClientRect();
  var relX = event.pageX - window.scrollX;
  var relY = event.pageY - window.scrollY;
  
  var x = relX - parentOffset.left;
  var y = relY - parentOffset.top;

  hoverImage.style.left = `${x}px`;
  // hoverImage.style.top = `${y}px`;
  // offset top with height of hover image
  const hoverImageHeight = hoverImage.clientHeight;
  hoverImage.style.top = `${y - hoverImageHeight}px`;
}

function j360_hover_image_mouse_out(event) {
  const [hoverImage] = document.getElementsByClassName('j360-list-hover-image');
  hoverImage.style.display = 'none';
}

function j360_hover_image_mouse_over(event) {
  const [hoverImage] = document.getElementsByClassName('j360-list-hover-image');
  hoverImage.style.display = 'block';

  // get data from event target
  const { currentTarget } = event;
  const { dataset } = currentTarget;
  const { imageUrl } = dataset;

  hoverImage.style.backgroundImage = `url(${imageUrl})`
}

window.j360_hover_image_mouse_move = j360_hover_image_mouse_move;
window.j360_hover_image_mouse_out = j360_hover_image_mouse_out;
window.j360_hover_image_mouse_over = j360_hover_image_mouse_over;